import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumbs from '../../components/Breadcrumbs';
import ErrorMessage from '../../components/ErrorMessage';
import { Container, PageTitle } from '../../components/Layout';
import LoadingState from '../../components/LoadingState';
import { useOrg } from '../org';
import windowService from '../../services/windowService';
import { AddSetting } from './components/AddSetting';
import { InviteGroup } from './models/inviteSettings';
import { getStoredInvite, updateStoredInvite } from './state/storedInviteState';
import { InviteUrlParams } from './models/inviteUrlParams';

type OrgGroup = InviteGroup & { curriculum?: object };

export const AddGroupsToInvite = () => {
  const { org, isLoading, error } = useOrg();
  const { orgId, inviteType } = useParams<InviteUrlParams>();

  const inviteSettingsPath = `#/invite/${orgId}/${inviteType}/settings`;

  const crumbs = [
    { name: 'Organization', route: '#/org' },
    { name: 'Advanced Invites', route: '#/invites' },
    { name: 'Invite Settings', route: inviteSettingsPath },
    { name: 'Add Groups' },
  ];

  const onGroupsSelected = (selectedItems: InviteGroup[]) => {
    updateStoredInvite(invite => ({ ...invite, groups: selectedItems }));
    windowService.redirectTo(inviteSettingsPath);
  };

  return (
    <div className="mb-64">
      <Breadcrumbs crumbs={crumbs} />

      <Container>
        <PageTitle className="mt-32 mb-32">
          <h1>Add Groups to Invite</h1>
          <p>Select the groups you would like to attach to your invite</p>
        </PageTitle>

        {isLoading ? (
          <LoadingState />
        ) : error || !org ? (
          <ErrorMessage />
        ) : (
          <AddSetting
            settingLabel="Groups"
            items={org?.groups?.filter((group: OrgGroup) => !group.curriculum) || []}
            preselectedItems={getStoredInvite()?.groups || []}
            onSubmit={onGroupsSelected}
          />
        )}
      </Container>
    </div>
  );
};
